import { Directive, effect, inject, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFieldService } from '../../services/form-field/form-field.service';

@Directive({
  selector: '[appFormFields]',
})
export class FormFieldsDirective {
  formFieldService = inject(FormFieldService);

  formGroup = input<FormGroup>();

  constructor() {
    effect(() => {
      const formGroup = this.formGroup();
      if (formGroup) {
        this.formFieldService.setForm(formGroup);
      }
    });
  }
}
